import { change } from 'redux-form';

const getSetValueFun = (dispatch, formName) => (field, value) => {
  dispatch(change(formName, field, value));
};

// eslint-disable-next-line import/prefer-default-export
export { getSetValueFun };
